module.exports = __webpack_public_path__ + "static/media/clipad.c91ba26f.jpg";